module.exports = __webpack_public_path__ + "img/gari.39d317c8.png";